import store from "@/store";
import VueRouter from "vue-router";

import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";

import Dashboard from "@/views/DashboardView/Dashboard.vue";

import MailTemplate from "@/views/MailtemplateView/MailTemplate.vue";

import authPages from "@/routes/auth";
import memberMenu from "@/routes/member";
import accountMenu from "@/routes/account";
import contentsMenu from "@/routes/contents";
import profileMenu from "@/routes/profile";
import paymentsMenu from "@/routes/payment";
import submissionsMenu from "@/routes/submission";
import reviewsMenu from "@/routes/review";
import conferenceMenu from "@/routes/conference";
import reviewersMenu from "@/routes/reviewer";
import finalReviewsMenu from "@/routes/finalReview";
import boardMenu from "@/routes/board";
import adminMenu from "@/routes/admin";
import journalMenu from "@/routes/journal";

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home",
  },
  authPages,
  memberMenu,
  accountMenu,
  contentsMenu,
  profileMenu,
  paymentsMenu,
  submissionsMenu,
  reviewsMenu,
  reviewersMenu,
  finalReviewsMenu,
  conferenceMenu,
  boardMenu,
  adminMenu,
  journalMenu,
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        components: { default: Dashboard },
        meta: { requiresAuth: true, title: "topnav.dashboard" },
      },
      {
        path: "mail-template",
        components: { default: MailTemplate },
        name: "mail-template",
        meta: {
          requiresAuth: true,
          requiredRoles: ["editor", "member", "account", "content", "master"],
          title: "topnav.mail_template",
        },
      },
    ],
  },
];

// configure router
const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash, behavior: "smooth" };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active",
});

/**
 * 네비게이션 가드
 */
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters["auth/isLoggedIn"];
  const userRoles = store.state.auth.roles || []; // 사용자 역할 확인

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 로그인하지 않은 상태라면 로그인 페이지로 이동
    if (!isLoggedIn) {
      return next("/login");
    }

    // 필요한 역할이 있는 경우 확인
    if (to.meta.requiredRoles) {
      const hasAccess = to.meta.requiredRoles.some((role) =>
        userRoles.includes(role)
      );
      if (!hasAccess) {
        return next("/dashboard");
      }
    }
  } else {
    // 로그인 상태이면 홈 페이지로 리다이렉트
    if (isLoggedIn) {
      return next("/dashboard");
    }
  }

  return next(); // 권한 문제가 없으면 다음 경로로 이동
});

export default router;
